import React from 'react';
import { Outlet } from 'react-router-dom';
import {useSelector} from 'react-redux';
import { isMobile } from 'react-device-detect';

const Aca=()=>{
    const furi = useSelector(state=>state.mahena);
 
return(
<>
{isMobile ? <div style={{height : "5px"}}></div> :
<div style={{height : "42px"}}></div>}
<Outlet/>
</>
);
}

export default Aca;